module.exports = () => {
    class Coffees {
        constructor(
            fontName,
            coffeeHtml,
            webhookUrl,
            coffeeId,
            origin,
            clientUrl,
            ecProductId,
            sendEmails,
            easyCartUrl,
            lang,
            mainColor,
            buttonTextColor,
            borderColor
        ) {
            this.fontName = fontName;
            this.coffeeHtml = coffeeHtml;
            this.webhookUrl = webhookUrl;
            this.coffeeId = coffeeId;
            this.origin = origin;
            this.clientUrl = clientUrl;
            this.ecProductId = ecProductId;
            this.sendEmails = sendEmails === "1" || sendEmails === "true";
            this.easyCartUrl = easyCartUrl;
            this.lang = lang;
            this.mainColor = mainColor;
            this.buttonTextColor = buttonTextColor;
            this.borderColor = borderColor;

            this.amount = "";
            this.note = "";

            this.coffee = document.createElement("div");
            this.styleLink = document.createElement("link");
            this.fontLink = document.createElement("link");

            this.appendCoffee();
        }

        appendCoffee() {
            this.styleLink.setAttribute("rel", "stylesheet");
            this.styleLink.setAttribute("as", "style");
            this.styleLink.setAttribute("href", "https://app.easy.tools/coffee/css/style.css");
            document.head.appendChild(this.styleLink);

            this.fontLink.setAttribute("rel", "stylesheet");
            this.fontLink.setAttribute(
                "href",
                `https://fonts.googleapis.com/css?family=${this.fontName.replaceAll(
                    " ",
                    "+"
                )}:300,400,500,600,700,800`
            );
            document.head.appendChild(this.fontLink);

            let styleLinkStatus = false;
            let fontLinkStatus = false;

            this.styleLink.onload = () => {
                styleLinkStatus = true;
                if (fontLinkStatus) {
                    this.whenLinksReady();
                }
            };

            this.fontLink.onload = () => {
                fontLinkStatus = true;
                if (styleLinkStatus) {
                    this.whenLinksReady();
                }
            };

            this.sendStats();
        }

        whenLinksReady() {
            //append element
            this.coffee.innerHTML = this.coffeeHtml;
            this.coffee.classList.add("easy-coffee");
            this.coffee.classList.add("hide");
            document.body.appendChild(this.coffee);

            //add event listeners
            this.coffee.addEventListener("mouseenter", this.showAdjust.bind(this));

            const showBtn = this.coffee.querySelector("[data-ecoffee-show]");
            showBtn.addEventListener("click", this.toggleAdjust.bind(this));

            const closeBtn = this.coffee.querySelector("[data-ecoffee-close]");
            closeBtn.addEventListener("click", this.closeAdjust.bind(this));

            const amountBtns = this.coffee.querySelectorAll("[data-ecoffee-amount]");
            amountBtns.forEach((btn) =>
                btn.addEventListener("click", this.selectAmount.bind(this))
            );

            const amountInput = this.coffee.querySelector("[data-ecoffee-input]");
            if (amountInput) {
                amountInput.addEventListener("keyup", this.changeAmount.bind(this));
            }

            const noteText = this.coffee.querySelector("[data-ecoffee-note]");
            if (noteText) {
                noteText.addEventListener("keyup", this.changeNote.bind(this));
            }

            const sendBtn = this.coffee.querySelector("[data-ecoffee-send]");
            sendBtn.addEventListener("click", this.sendData.bind(this));

            this.clearButtons();
            this.clearInput();
            this.updateAmount();
            if (amountBtns[1]) {
                amountBtns[1].click();
            }

            //show coffee
            setTimeout(() => {
                this.coffee.classList.remove("hide");
            }, 100);
        }

        toggleAdjust() {
            const adjust = this.coffee.querySelector("[data-ecoffee-adjust]");
            if (adjust.classList.contains("hidden")) {
                this.showAdjust();
            } else {
                this.closeAdjust();
            }
        }

        showAdjust() {
            const showBtn = this.coffee.querySelector("[data-ecoffee-show]");
            showBtn.classList.add("is-open");

            const adjust = this.coffee.querySelector("[data-ecoffee-adjust]");
            adjust.classList.remove("hidden");
            this.coffee.querySelector("[data-ecoffee-logo-cup]").classList.add("hidden");
            this.coffee.querySelector("[data-ecoffee-logo-x]").classList.remove("hidden");
            setTimeout(() => {
                adjust.classList.remove("opacity-0");
            }, 100);
        }

        closeAdjust() {
            const adjust = this.coffee.querySelector("[data-ecoffee-adjust]");
            adjust.classList.toggle("opacity-0");
            this.coffee.querySelector("[data-ecoffee-logo-x]").classList.add("hidden");
            this.coffee.querySelector("[data-ecoffee-logo-cup]").classList.remove("hidden");
            setTimeout(() => {
                adjust.classList.toggle("hidden");

                const showBtn = this.coffee.querySelector("[data-ecoffee-show]");
                showBtn.classList.remove("is-open");
            }, 500);
        }

        selectAmount(e) {
            this.clearButtons();
            this.clearInput();
            this.selectButton(e.target);
            this.enableSend();
            this.amount = e.target.getAttribute("data-ecoffee-amount");
            this.updateAmount();
        }

        selectButton(btn) {
            btn.style.backgroundColor = this.mainColor;
            btn.style.color = this.buttonTextColor;
            btn.style.borderColor = this.mainColor;
            btn.style.opacity = "1";
        }

        unselectButton(btn) {
            btn.style.backgroundColor = "";
            btn.style.color = "";
            btn.style.borderColor = this.borderColor;
            btn.style.opacity = "";
        }

        changeAmount(e) {
            if (e.target.value) {
                this.clearButtons();
                this.enableSend();
                this.amount = e.target.value;
            } else {
                this.disableSend();
                this.amount = "";
            }
            this.updateAmount();
        }

        updateAmount() {
            if (this.amount) {
                document
                    .querySelector("[data-ecoffee-selected-container]")
                    .classList.remove("hidden");
            } else {
                document.querySelector("[data-ecoffee-selected-container]").classList.add("hidden");
            }
            document.querySelector("[data-ecoffee-selected-amount]").innerText = this.amount;
        }

        changeNote(e) {
            this.note = e.target.value;
        }

        async getEcLink() {
            const dataToSent = {
                product_id: this.ecProductId,
                amount: this.amount,
                lang: this.lang,
                params: {
                    note: this.note,
                    easycoffee: Boolean(this.sendEmails),
                    lang: this.lang,
                },
            };

            try {
                const result = await fetch(`${this.easyCartUrl}easytools/dynamic-price`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify(dataToSent),
                });
                if (!result.ok) {
                    throw new Error(`Fetch failed: (${result.status}) ${result.statusText}`);
                }
                const { url } = await result.json();
                return url;
            } catch (e) {
                console.error("Cannot fetch data from Easycart");
                console.error(e);
                return "";
            }
        }

        async sendData() {
            if (!this.amount) {
                this.disableSend();
                return false;
            }
            const finalLink = await this.getEcLink();
            if (!finalLink) {
                return console.warn("Cannot link to product");
            }
            if (this.webhookUrl) {
                this.sendWebhook({
                    note: this.note,
                    amount: this.amount,
                });
            }
            this.showThankYou();
            setTimeout(() => {
                window.location = finalLink;
            }, 300);
        }

        showThankYou() {
            this.coffee.querySelector("[data-ecoffee-details]").classList.add("hidden");
            this.coffee.querySelector("[data-ecoffee-thanks]").classList.remove("hidden");
            this.coffee.querySelector("[data-ecoffee-show]").classList.add("open");
            this.coffee.querySelector("[data-ecoffee-logo-x]").classList.add("hidden");
            this.coffee.querySelector("[data-ecoffee-logo-heart]").classList.remove("hidden");
        }

        clearButtons() {
            const amountBtns = this.coffee.querySelectorAll("[data-ecoffee-amount]");
            amountBtns.forEach((btn) => this.unselectButton(btn));
        }

        clearInput() {
            const amountInput = this.coffee.querySelector("[data-ecoffee-input]");
            amountInput.value = "";
        }

        enableSend() {
            const sendBtn = this.coffee.querySelector("[data-ecoffee-send]");
            sendBtn.removeAttribute("disabled");
        }

        disableSend() {
            const sendBtn = this.coffee.querySelector("[data-ecoffee-send]");
            sendBtn.setAttribute("disabled", "disabled");
        }

        sendWebhook(data) {
            const dataToSent = data;
            dataToSent.location = window.location.href;

            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", this.webhookUrl, true);
            xhttp.setRequestHeader("Content-type", "application/json");
            xhttp.send(JSON.stringify(dataToSent));
        }

        sendStats() {
            const appHostname = new URL(this.origin).hostname;
            const url = window.location.hostname;
            if (!url || url === appHostname) {
                return false;
            }
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", `${this.origin}/api/stats`, true);
            xhttp.setRequestHeader("Content-type", "application/json");
            xhttp.send(
                JSON.stringify({
                    coffeeId: this.coffeeId,
                    type: "coffee",
                    url: window.location.href,
                    uuid: undefined, // todo uuid for stats.
                })
            );
        }
    }

    document.addEventListener("DOMContentLoaded", function () {
        new Coffees(
            "fontNameToReplace",
            "coffeeHtmlToReplace",
            "webhookUrlToReplace",
            "coffeeIdToReplace",
            "originToReplace",
            "clientUrlToReplace",
            "ecProductIdToReplace",
            "sendEmailsToReplace",
            "easyCartUrlToReplace",
            "langToReplace",
            "mainColorToReplace",
            "buttonTextColorToReplace",
            "borderColorToReplace"
        );
    });
};
